module.exports = __webpack_public_path__ + "static/img/survey@2x.96646119.png";